import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { createEpicMiddleware } from "redux-observable";
import { rootEpic } from "../epics/root.Epic";
import ProjectsSlice from "./dashboard/ProjectsSlice";
import AuthSlice from "./dashboard/AuthSlice";
import ProjectTabSlice from './calculation/calculation-input/ProjectTabSlice';
import TubingSlice from "./calculation/calculation-input/TubingSlice";
import FluidSlice from './calculation/calculation-input/FluidSlice';
import CalculationSlice from "./calculation/calculationSlice";
import OthersSlice from "./calculation/calculation-input/OthersSlice";
import WellSlice from "./calculation/calculation-input/WellSlice";
import projectHeaderSlice from "./calculation/calculation-input/ProjectHeaderSlice";
import gasCalculationSlice from "./calculation/calculation-output/gasCalculaionSlice";
import gasHandlerSlice from "./calculation/calculation-output/gasHandlerSlice";
import basicCalculationSlice from "./calculation/calculation-output/basicCalculationSlice";
import createProjectSlice from "./dashboard/CreateProjectSlice";
import ComparisonSlice from "./comparison/comparisonSlice";
import PumpSlice from "./calculation/calculation-output/pumpSlice"
import CollapseSlice from "./collapse/collaspeSlice";
import protectorSlice from "./calculation/calculation-output/protectorSlice";
import motorSlice from "./calculation/calculation-output/motorSlice";
import cableSlice from "./calculation/calculation-output/cableSlice";
import schematicSlice from "./calculation/calculation-output/schematicSlice";
import wellSurveyReducer from "./calculation/calculation-output/wellSurveySlice";
import ReportSlice from "./reports/reportsSlice";
import surfaceEquipmentSlice from "./calculation/calculation-output/surfaceEquipmentSlice";
import SummarySlice from "./dashboard/SummarySlice";
import DocumentsSlice from "./documents/DocumentsSlice";
import commentsSlice from "./comments/commentSlice";
import EquipmentCatalogSlice from "./equipment-catalog/EquipmentCatalogSlice";
import { AnyAction } from "redux";

import { initialState as myProjectsState } from "./dashboard/ProjectsSlice";
import { initialState as tubingState } from "./calculation/calculation-input/TubingSlice";
import { initialState as FluidState } from "./calculation/calculation-input/FluidSlice";
import { initialState as otherState } from "./calculation/calculation-input/OthersSlice";
import { initialState as calculationState } from "./calculation/calculationSlice";
import { initialState as gasCalculaionState } from "./calculation/calculation-output/gasCalculaionSlice";
import { initialState as wellState } from "./calculation/calculation-input/WellSlice";
import { initialState as headerState } from "./calculation/calculation-input/ProjectHeaderSlice";
import { initialState as gasHandlerState } from "./calculation/calculation-output/gasHandlerSlice";
import { initialState as basicCalculationState } from "./calculation/calculation-output/basicCalculationSlice";
import { initialState as pumpState } from "./calculation/calculation-output/pumpSlice";
import { initialState as collapseState } from "./collapse/collaspeSlice";
import { initialState as protectorState } from "./calculation/calculation-output/protectorSlice";
import { initialState as motorState } from "./calculation/calculation-output/motorSlice";
import { initialState as cableState } from "./calculation/calculation-output/cableSlice";
import { initialState as schematicState } from "./calculation/calculation-output/schematicSlice";
import { initialState as wellSurveyState } from "./calculation/calculation-output/wellSurveySlice";
import { initialState as surfaceEquipmentState } from "./calculation/calculation-output/surfaceEquipmentSlice";
import { initialState as reportsState } from "./reports/reportsSlice";
import { initialState as summaryState } from "./dashboard/SummarySlice";
import { initialState as comparisonState } from "./comparison/comparisonSlice";
import { initialState as documentsState } from "./documents/DocumentsSlice";
import { initialState as createProjectState } from "./dashboard/CreateProjectSlice";
import { initialState as commentsState } from "./comments/commentSlice";
import { initialState as equipmentCatalogState } from "./equipment-catalog/EquipmentCatalogSlice";
import { rootJetliftReducer } from "./JetliftStore";

const reducer = combineReducers({
    auth: AuthSlice,
    myProjects: ProjectsSlice,
    projectTab: ProjectTabSlice,
    tubing: TubingSlice,
    wellInput: WellSlice,
    fluid: FluidSlice,
    calculations: CalculationSlice,
    others: OthersSlice,
    projectHeader: projectHeaderSlice,
    gasCalculations: gasCalculationSlice,
    gasHandler: gasHandlerSlice,
    basicCalculations: basicCalculationSlice,
    createProject: createProjectSlice,
    comparison: ComparisonSlice,
    pump: PumpSlice,
    collapse: CollapseSlice,
    protector: protectorSlice,
    motor: motorSlice,
    cable: cableSlice,
    schematic: schematicSlice,
    wellSurvey: wellSurveyReducer,
    reports: ReportSlice,
    surfaceEquipment: surfaceEquipmentSlice,
    summary: SummarySlice,
    documents: DocumentsSlice,
    comments: commentsSlice,
    equipmentCatalog: EquipmentCatalogSlice,
    jetlift: rootJetliftReducer
});
const epicMiddleware = createEpicMiddleware();

const rootReducer = (state: ReturnType<typeof reducer> | undefined, action: AnyAction) => {
    if (action.type === 'RESET_STORE') {
        return reducer({
            ...state,
            myProjects: myProjectsState,
            tubing: tubingState,
            wellInput: wellState,
            fluid: FluidState,
            others: otherState,
            calculations: calculationState,
            projectHeader: headerState,
            gasCalculations: gasCalculaionState,
            gasHandler: gasHandlerState,
            basicCalculations: basicCalculationState,
            pump: pumpState,
            collapse: collapseState,
            protector: protectorState,
            motor: motorState,
            cable: cableState,
            schematic: schematicState,
            wellSurvey: wellSurveyState,
            reports: reportsState,
            surfaceEquipment: surfaceEquipmentState,
            summary: summaryState,
            comparison: comparisonState,
            documents: documentsState,
            createProject: createProjectState,
            comments: commentsState,
            equipmentCatalog: equipmentCatalogState,
        }, action);
    }
    return reducer(state, action);
};

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(epicMiddleware),
});

epicMiddleware.run(rootEpic);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;